import React, { Component } from 'react';
import { Button, Modal, Form } from 'semantic-ui-react'

import { getRiskColumnsByLanguage } from '../../helpers'

import './index.css'

class ExportModal extends Component {
  constructor(props){
    super(props);

    const plan_ids = props.plans ? props.plans.map((plan) => { return plan.id }) : [];

    this.state = {
      columns: [],
      plan_ids: plan_ids
    }
  }

  componentDidMount = () => {
    this.onSelectAll();
  }

  componentWillReceiveProps = (nextProps) => {
    if(this.props.pending !== nextProps.pending && !nextProps.pending){
      this.props.onClose()
    }
    if (nextProps.shown && this.props.shown !== nextProps.shown) {
      this.onSelectAll();
    }
  }

  getOptions = () => {
    const { translations, languageName } = this.props
    const riskColumns = getRiskColumnsByLanguage(languageName);
    return [
      {
        dataField: riskColumns.work_phase,
        text: translations.work_phase_or_ambient_exposure
      },
      {
        dataField: riskColumns.activity,
        text: translations.activity
      },
      {
        dataField: riskColumns.hazard,
        text: translations.hazard
      },
      {
        dataField: riskColumns.unwanted_event,
        text: translations.unwanted_event
      },
      {
        dataField: 'existing_preventative',
        text: translations.existing_preventative_controls
      },
      {
        dataField: 'existing_recovery',
        text: translations.existing_recovery_controls
      },
      {
        dataField: 'likelihood',
        text: translations.likelihood_of_unwanted_event
      },
      {
        dataField: 'consequences_description',
        text: translations.consequence_text_description
      },
      {
        dataField: 'financial',
        text: translations.financial
      },
      {
        dataField: 'safety',
        text: translations.safety
      },
      {
        dataField: 'health',
        text: translations.occ_health
      },
      {
        dataField: 'reputation',
        text: translations.reputation
      },
      {
        dataField: 'environmental',
        text: translations.environment
      },
      {
        dataField: 'legal',
        text: translations.legal
      },
      {
        dataField: 'community',
        text: translations.community
      },
      {
        dataField: 'current_risk_rating',
        text: translations.current_risk_rating
      },
      {
        dataField: 'actions',
        text: translations.numbered_1
      },
      {
        dataField: 'manager',
        text: translations.numbered_2
      },
      {
        dataField: 'effectiveness',
        text: translations.numbered_3
      },
      {
        dataField: 'status',
        text: translations.numbered_4
      },
      {
        dataField: 'effectiveness2',
        text: translations.numbered_5
      }
    ];
  }

  onChange = (evt, data) => {
    var columns = this.state.columns
    if (data.checked && !columns.includes(data.value)){
      columns.push(data.value)
    } else if (columns.includes(data.value)) {
      var index = columns.indexOf(data.value);
      if (index !== -1) columns.splice(index, 1);
    }
    this.setState({
      columns: columns
    })

  }

  onSelectAll = (evt) => {
    var columns = this.state.columns
    if (columns.length > 0) {
      columns = []
    }

    var options = this.getOptions();
    options.map((item, index)=>{
      columns.push(item.dataField);
      return true
    })
    this.setState({
      columns: columns
    })
  }

  onUnselectAll = (evt) => {
    this.setState({
      columns: []
    })
  }

  removePlanId = (plan_id) => {
    let { plan_ids } = this.state;
    plan_ids = plan_ids.filter(id => id !== plan_id);
    this.setState({ plan_ids });
  }

  render() {
    const { trigger, type, shown, onClose, pending, onExport, plans } = this.props;
    const { export_to_excel, export_to_pdf, export_label, select_columns_for_export, select_all, unselect_all, export_descriptions } = this.props.translations
    const headerText = type === "Excel" ? export_to_excel : export_to_pdf;
    const options = this.getOptions();
    const { columns, plan_ids } = this.state;
    const selected_plans = plans ? plans.filter(plan => plan_ids.includes(plan.id) ) : [];

    return (
      <Modal className='export-modal' trigger={trigger} size="tiny" open={shown}>
        <Modal.Header>{headerText}</Modal.Header>
        <Modal.Content>
          <Form>
            {
              selected_plans && selected_plans.length > 0 &&
              <div className='export-descriptions'>
                <label>{export_descriptions}:</label>
                {
                  selected_plans.map((plan, index)=>{
                    return (<span className="badge">{plan.name} <i aria-hidden="true" className="delete icon" onClick={(evt)=>this.removePlanId(plan.id)}></i></span>)
                  })
                }
              </div>
            }
            <div className='sub-header-container'>
              <span className='sub-header'>{select_columns_for_export}</span>
              <span className='export-quick-actions'>
                <u onClick={this.onSelectAll}>{select_all}</u>
                <u onClick={this.onUnselectAll}>{unselect_all}</u>
              </span>
            </div>
            {
              options &&
              <div className='export-checkboxes'>
                {
                  options.map((item, index)=>{
                    if (index <= 15){
                      return (
                        <Form.Checkbox key={index} label={item.text} value={item.dataField} onChange={this.onChange} checked={columns.includes(item.dataField)}/>
                      )
                    } else {
                      return true
                    }

                  })
                }
              </div>
            }
            {
              options &&
              <div className='export-checkboxes'>
                {
                  options.map((item, index)=>{
                    if (index > 15){
                      return (
                        <Form.Checkbox key={index} label={item.text} value={item.dataField} onChange={this.onChange} checked={columns.includes(item.dataField)}/>
                      )
                    } else {
                      return true
                    }
                  })
                }
              </div>
            }

          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button color='teal' disabled={columns.length === 0 || pending} fluid size='medium' onClick={(evt) => onExport(type, columns, plan_ids)} className="new-plan-button">{(pending) && <i className="loading circle notched icon"></i>} {export_label}</Button>
        </Modal.Actions>
        <i className="delete icon" onClick={onClose}></i>
      </Modal>
    )
  }
}

export default ExportModal



// WEBPACK FOOTER //
// ./src/components/export_modal/index.js